import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { cartLinesListHeaderStyles } from "@insite/content-library/Components/CartLinesListHeader";
import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";
import { customerSelectorStyles } from "@insite/content-library/Components/CustomerSelector";
import { checkoutShippingCarrierServiceStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService";
import { checkoutReviewAndSubmitHeaderStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { pageContainerStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer";
import { checkoutReviewAndSubmitPaymentDetailsStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import { creditCardBillingAddressEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardBillingAddressEntry";
import { creditCardDetailsEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import { billingAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/BillingAddress";
import { containerStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingPageContainer";
import { shippingAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/ShippingAddress";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import get from "@insite/mobius/utilities/get";
import getColor from "@insite/mobius/utilities/getColor";
import styled, { css } from "styled-components";

customerCardStyles.editLink = {
    css: css`
        margin-top: 1rem;
        display: none;
    `,
};

pageContainerStyles.productListGridItemWide = {
    width: 12,
    css: css`
        [data-test-selector="cardLinesList_current"] {
            & section {
                padding: 12px 5px 8px;
            }
            >div: first-child {
                > div[class^="CheckboxGroupStyle"] {
                    display: none;
                }
            }
        }
    `,
};

pageContainerStyles.productListGridItemNarrow = {
    width: 12,
    css: css`
        [data-test-selector="cardLinesList_current"] {
            & section {
                padding: 12px 15px 8px 0px;
            }

            >div: first-child {
                > div[class^="CheckboxGroupStyle"] {
                    display: none;
                }
            }
            > div[class^="GridWrapper"] {
                > div[class^="GridOffset"] {
                    >div: first-child {
                        flex-basis: 100%;
                        max-width: 100%;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    flex-basis: 100%;
                                    max-width: 100%;
                                `,
                                css`
                                    flex-basis: 100%;
                                    max-width: 100%;
                                `,
                                css`
                                    flex-basis: 100%;
                                    max-width: 100%;
                                `,
                                null,
                                null,
                            ])}
                    }
                }
            }
        }
    `,
};

// checkoutHeader

checkoutReviewAndSubmitHeaderStyles.buttonsWrapper = {
    css: css`
        display: flex;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    position: fixed;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    background: ${getColor("common.background")({ theme })};
                    justify-content: center;
                    z-index: ${get(theme, "zIndex.stickyFooter")};
                `,
                css`
                    margin-left: 16px;
                    display: flex;
                    flex-direction: column;
                    [data-test-selector="checkoutReviewAndSubmitHeader_backButton"] {
                        justify-content: center;
                        display: flex;
                        margin: 6px;
                        align-items: center;
                    }
                    [data-test-selector="checkoutReviewAndSubmit_placeOrder"] {
                        margin: 7px;
                    }
                `,
                css`
                    margin-left: auto;
                    display: flex;
                    flex-direction: column;
                    [data-test-selector="checkoutReviewAndSubmitHeader_backButton"] {
                        justify-content: center;
                        display: flex;
                        margin: 6px;
                        align-items: center;
                    }
                    [data-test-selector="checkoutReviewAndSubmit_placeOrder"] {
                        margin: 7px;
                    }
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
            ])}
    `,
};

billingAddressStyles.headingText = mergeToNew(billingAddressStyles.headingText, {
    css: css`
        margin-bottom: 0;
        ~ button {
            padding-bottom: 3px;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    margin-bottom: 27px;
                    font-size: 18px;
                `,
                css`
                    margin-bottom: 27px;
                    font-size: 18px;
                `,
            ])}
    `,
});

containerStyles.headerGridItem = mergeToNew(containerStyles.headerGridItem, {
    css: css`
        padding-bottom: 5px;
        & h1 {
            margin-bottom: 0 !important;
        }
    `,
});

containerStyles.addressesGridItem = mergeToNew(containerStyles.addressesGridItem, {
    css: css`
        padding-top: 0;
    `,
});

billingAddressStyles.selectSavedAddressLink = mergeToNew(billingAddressStyles.selectSavedAddressLink, {
    css: css`
        margin-left: 20px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    margin-bottom: 22px;
                `,
                css`
                    margin-bottom: 22px;
                `,
            ])}
    `,
});

shippingAddressStyles.selectSavedAddressLink = mergeToNew(shippingAddressStyles.selectSavedAddressLink, {
    css: css`
        margin-left: 20px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    margin-left: 6px;
                `,
                null,
            ])}
    `,
});

cartLinesListHeaderStyles.checkboxGroup = mergeToNew(cartLinesListHeaderStyles.checkboxGroup, {
    css: css`
        display: none;
    `,
});

creditCardBillingAddressEntryStyles.heading = mergeToNew(creditCardBillingAddressEntryStyles.heading, {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    margin-bottom: 0;
                `,
                css`
                    margin-bottom: 0;
                `,
            ])}
    `,
});

creditCardBillingAddressEntryStyles.useBillingAddressGridItem = {
    css: css`
        padding-top: 0;
        [data-test-selector="checkoutReviewAndSubmit_useBillingAddress"]{
            margin-top: 37px;
            white-space: nowrap;
        }
    `,
}

creditCardDetailsEntryStyles.creditCardDetailsHeading = mergeToNew(
    creditCardDetailsEntryStyles.creditCardDetailsHeading,
    {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        margin-bottom: 2rem;
                    `,
                    css`
                        margin-bottom: 2rem;
                    `,
                ])}
        `,
    },
);

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodGridItem = {
    width: 6,
    css: css`
        flex-direction: column;
        select[data-test-selector="checkoutReviewAndSubmit_paymentMethod"] {
            padding-right: 20px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    `,
};

// Checkout-Shipping  Modal Pagination

customerSelectorStyles.pagination = {
    cssOverrides: {
        pagination: css`
            @media print {
                display: none;
            }
            margin: 0 !important;
            select {
                font-size: 15px !important;
            }
        `,
        perPageSelect: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 30%;
                        `,
                    ],
                    "max",
                )}
            > div {
                padding: 0;
                width: auto;
                label {
                    width: auto;
                    font-size: 12px;
                    padding-top: 11px;
                    padding-right: 0;
                    text-transform: uppercase;
                    & + div {
                        width: auto;
                        select {
                            padding-right: 30px !important;
                            border-width: 0 !important;
                            background-color: #f7f7f7 !important;
                        }
                    }
                }
            }
        `,
        linkList: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 70%;
                        `,
                    ],
                    "max",
                )}
            ul li {
                button {
                    max-width: 30px;
                    span {
                        font-size: 12px;
                    }
                    border: none;
                    > span {
                        color: #353432;
                        &:hover {
                            color: #0000ff !important;
                        }
                    }
                    background-color: #f7f7f7 !important;
                    width: 20px;
                    height: 20px;
                    padding: 0px;
                    &:hover {
                        background-color: #f7f7f7 !important;
                        color: #0000ff !important;
                        border: 0.5px solid #0000ff !important;
                    }
                }
            }
        `,
        currentButton: css`
            width: 20px;
            height: 20px;
            padding: 0px;
            color: #0000ff;
            background-color: #f7f7f7;
            border: 0.5px solid #0000ff;
            > span {
                color: #0000ff;
            }
            &:hover {
                background-color: #f7f7f7 !important;
                color: #0000ff !important;
                border: 0.5px solid #0000ff;
            }
        `,
    },
};

// Checkout - Review & Submit page calendar.

checkoutShippingCarrierServiceStyles.deliveryDateGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        position: relative;
        .react-datetime-picker__inputGroup {
            pointer-events: none;
        }
        .react-calendar {
            .react-calendar__viewContainer {
                .react-calendar__month-view {
                    .react-calendar__month-view__days {
                        .react-calendar__tile--now {
                            color: ${getColor("primary")};
                            cursor: default;
                            border: none;
                            &: disabled;
                            border-radius: 50%;
                            font-size: 16px;
                            padding: 9.5px;
                            background-color: #ffffff;
                            pointer-events: none;
                        }
                    }
                }
            }
        }
    `,
};
